import React, { useCallback } from "react";
import { useActivities } from "../features/activity/hooks/useActivities";
import { ImageList, SpinAnimation, Chip } from "@twioku/common_components";
import { Path } from "../routes/PagePath";
import { useNavigate } from "react-router-dom";
import { useActivityRepliesUnreadStatus } from "../features/activityReply/hooks/useActivityRepliesUnreadStatus";
export const ActivitiesPage: React.FC = () => {
    const navigate = useNavigate();
    const { activities, isLoading } = useActivities();
    const maxThumbnail = 4;

    const { hasNewActivityReplyByActivityId } =
        useActivityRepliesUnreadStatus();

    const gotoActivityDetailPage = useCallback(
        (e: React.MouseEvent<HTMLDivElement>, activityId: string) => {
            navigate(`${Path.activityDetail}/${activityId}`);
        },
        [navigate]
    );

    if (isLoading)
        return (
            <div className="absolute inset-0 flex items-center justify-center">
                <SpinAnimation />
            </div>
        );

    return (
        <div className="p-4">
            <div className="mb-6 rounded-lg p-4">
                <h3 className="mb-2 font-bold text-gray-800">
                    アクティビティとは？
                </h3>
                <p className="mb-2 text-sm text-gray-700">
                    アクティビティとは、ある期間中にテーマに沿って写真を共有するイベントです。
                </p>
                <p className="text-sm text-gray-700">
                    お写真が共有されると、こちらのページからご覧いただけます。
                </p>
            </div>
            {activities.length === 0 ? (
                <div className="flex justify-center py-8 text-gray-500">
                    まだアクティビティがありません。もうしばらくお待ちください。
                </div>
            ) : (
                <div className="flex flex-col gap-4">
                    {activities.map((activity) => (
                        <div
                            key={activity.id}
                            className="flex cursor-pointer flex-col gap-2"
                            onClick={(e) =>
                                gotoActivityDetailPage(e, activity.id)
                            }
                        >
                            <h2 className="border-l-4 border-primary px-3 text-lg">
                                {activity.title}
                            </h2>
                            <div className="pointer-events-none relative">
                                {hasNewActivityReplyByActivityId(
                                    activity.id
                                ) && (
                                    <div className="absolute left-2 top-2">
                                        <Chip color="success">新着あり</Chip>
                                    </div>
                                )}
                                <ImageList
                                    className="pointer-events-none"
                                    srcList={
                                        activity.respondedActivityReply
                                            .flatMap((x) => x.imagePaths)
                                            .slice(0, maxThumbnail) ?? []
                                    }
                                />
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};
